import React, { useEffect, useState } from "react";

import { useTodosContext } from "./context/todoContext";

import NewTodo from "./Components/NewTodo/NewTodo";
import Todos from "./Components/Todos/Todos";

import iconMoon from "./assets/images/icon-moon.svg";
import iconSun from "./assets/images/icon-sun.svg";

const App = () => {
  const [darkTheme, setDarkTheme] = useState(
    JSON.parse(localStorage.getItem("dark")) || false
  );

  const toggleTheme = () => {
    setDarkTheme((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem("dark", JSON.stringify(darkTheme));
  }, [darkTheme]);

  return (
    <div
      className={
        darkTheme ? "app-container dark-theme" : "app-container light-theme"
      }
    >
      <header className="header">
        <h1>todo</h1>
        <button onClick={toggleTheme} className="btn btn-theme">
          <img
            src={darkTheme ? iconSun : iconMoon}
            alt="icon"
            className="icon-theme"
          />
        </button>
      </header>
      <NewTodo />
      <Todos />
    </div>
  );
};

export default App;
